import { type SVGAttributes } from "react";

export function CheckmarkFilledIcon({
  ...props
}: SVGAttributes<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="M12 3.25C7.16751 3.25 3.25 7.16751 3.25 12C3.25 16.8325 7.16751 20.75 12 20.75C16.8325 20.75 20.75 16.8325 20.75 12C20.75 7.16751 16.8325 3.25 12 3.25ZM16.2804 10.0303L15.2197 8.96967L10.7501 13.4393L8.78039 11.4697L7.71973 12.5303L10.7501 15.5607L16.2804 10.0303Z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
